export default "<h1>支払い方法の変更</h1>\n\n<div class=\"settings-card\">\n    <support-card-register (back)=\"back()\"></support-card-register>\n</div>"